import { EXERCISES, STEPS } from '@/constants';
import { pickKeys } from '@/composables';

export default {
  getIntroduce: state => pickKeys(
    EXERCISES[state.currentExercise],
    ['title', 'description'],
  ),

  getEndText: state => EXERCISES[state.currentExercise]?.endText,
  getInstructions: state => EXERCISES[state.currentExercise]?.instruction,
  getExerciseTitle: state => EXERCISES[state.currentExercise]?.title,
  getNumberOfSuccessAttempts:
      state => EXERCISES[state.currentExercise]?.numberOfSuccessAttempts,
  getStepView: state => STEPS[state.currentStep],
  getExerciseView: state => EXERCISES[state.currentExercise].view,
  isLogsEmpty: state => Object
    .keys(state.logs)
    .some(key => state.logs[key] === null),
};
